module.exports = __webpack_public_path__ + "static/media/cactus.353d8ddc.svg";